import { FC } from 'react';

import { Trans, useTranslation } from '@gem/modules/i18n';
import { Link } from '@gem/ui-kit';

import Tasks from 'APP/Tasks';

export const LoginRegionSupportInfo: FC = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Trans
        translateKey={'auth_help_text'}
        keyParams={{
          0: (
            <Link
              color="primary"
              underline={false}
              onClick={(): void => {
                Tasks.app.openSupport();
              }}
            >
              {t('about_contact_support')}
            </Link>
          ),
        }}
      />
    </div>
  );
};
